import styled, { css } from 'styled-components';
import {
  NavBarHeight,
  NavBarHeightMobile,
  SubNavBarHeight,
  SubNavBarHeightMobile,
} from '../../../const';

const maxWidthSubNavbar = 350;

export const SubNavBarBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: var(--full-width);
  height: 100vh;
  z-index: 15;
  display: none;
  @media ${(props) => props.theme.device.tabletL} {
    display: block;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0;

  @media ${(props) => props.theme.device.tabletL} {
    overflow: overlay;
    white-space: nowrap;
    flex-direction: column;
    align-items: start;
    position: absolute;
    top: calc(${NavBarHeightMobile}px + ${SubNavBarHeightMobile}px);
    left: 0px;
    height: calc(100% - ${NavBarHeightMobile}px - ${SubNavBarHeightMobile}px);
    align-items: flex-start;
    width: 100%;
    max-width: ${maxWidthSubNavbar}px;
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
    justify-content: start;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

export const LogoWrapper = styled.div`
  margin-right: 40px;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  margin: auto;

  @media ${(props) => props.theme.device.laptop} {
    gap: 12px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    max-width: 350px;
    margin: 0;
    flex-direction: column;
    gap: 0;
  }
`;

export const SubMenuElementContainer = styled.button.withConfig({
  shouldForwardProp: (prop) => !['active'].includes(prop),
})`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 16px;
  transition: ${(props) => props.theme.constants.transitionBase};
  order: ${({ order }) => order};

  &:hover,
  &:focus-visible {
    & h3 {
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0.4px;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  svg {
    fill: none;
    stroke: ${(props) => props.theme.colors.white};
  }

  ${(props) =>
    props.active &&
    css`
      &:after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: -10px;
        background-color: ${props.theme.colors.white};
        height: 2px;
        width: calc(100% + 20px);
      }

      &:hover,
      &:focus-visible {
        & h3 {
          &::after {
            content: '';
            display: none;
          }
        }
      }
    `};

  @media ${(props) => props.theme.device.tablet} {
    font-size: 14px;
    max-width: 100%;

    &:after {
      bottom: 73px;
      left: -10px;
    }
  }

  .icon-chevron-right {
    display: none;
  }

  @media ${(props) => props.theme.device.tabletL} {
    text-align: start;
    display: flex;
    justify-content: space-between;
    font-size: 14px;

    ${(props) =>
      props.active &&
      css`
        &:after {
          content: '';
          margin-right: 0px;
          position: absolute;
          bottom: 0px;
          left: 0;
          background-color: ${({ theme }) => theme.colors.white};
          height: 100%;
          width: 4px;
        }
      `};

    &:hover {
      & h3 {
        &::after {
          content: '';
          display: none;
        }
      }
    }

    .icon-chevron-right {
      display: block;
    }
  }
`;

export const SubNavBarContainer = styled.nav.withConfig({
  shouldForwardProp: (prop) => prop !== 'navigationMobile',
})`
  position: sticky;
  top: ${NavBarHeight}px;
  width: 100%;
  height: ${SubNavBarHeight}px;
  color: ${(props) => props.theme.colors.white};
  z-index: ${(props) => props.theme.zIndex.subNavBar};
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.bgSubHeader};

  &.header-wrapper {
    width: 100%;
    margin: 0;
    z-index: ${(props) => props.theme.zIndex.headerWrapper};
    margin-left: auto;
  }

  .content-wrapper {
    padding: 0 30px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    display: none;
    position: fixed;
    top: ${NavBarHeight}px;
    left: 0;
    z-index: ${(props) => props.theme.zIndex.navBar - 1};

    &.slideout {
      @keyframes slideout {
        0% {
          display: block;
          left: max(calc(100% - ${maxWidthSubNavbar}px), 20%);
        }
        99% {
          display: block;
          left: 99%;
        }
        100% {
          display: none;
          left: 100%;
        }
      }
      animation: 0.25s linear slideout;
    }
  }

  ${({ navigationMobile }) =>
    navigationMobile &&
    css`
      @media ${(props) => props.theme.device.tabletL} {
        display: block;
        height: 100%;
        padding: 0 20px;
        width: min(450px, 80%);
        left: max(calc(100% - ${maxWidthSubNavbar}px), 20%);
        top: 0;

        general-container div {
          height: 100vh;
          flex-direction: column;
          padding: 0;
          div {
            div {
              white-space: nowrap;
              margin-right: 20px;
              margin-left: 0px;
            }
          }
        }
        @keyframes slidein {
          0% {
            left: 100%;
          }
          100% {
            left: max(calc(100% - ${maxWidthSubNavbar}px), 20%);
          }
        }

        &.slidein {
          animation: 0.25s linear slidein;
        }
      }
    `}
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 120px;
  width: 100%;
  display: flex;

  & button {
    margin: 0 auto;
    max-width: 140px;
  }
`;

export const StaticLinks = styled.div`
  width: 100%;
  max-width: ${maxWidthSubNavbar}px;
  background-color: ${(props) => props.theme.colors.white};
  width: 100%;
  max-width: 350px;
  padding: 24px 0;
  color: ${(props) => props.theme.colors.link};

  .link {
    cursor: pointer;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    svg {
      stroke: ${(props) => props.theme.colors.link};
    }

    &.active {
      position: relative;
      > h3:after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0;
        background-color: ${(props) => props.theme.colors.link};
        height: 100%;
        width: 4px;
      }

      svg {
        fill: ${(props) => props.theme.colors.link} !important;
      }
    }
  }
`;

export const TutorLinks = styled.div`
  background-color: #014c99;
  width: 100%;
  max-width: 350px;
  padding: 24px 0;
  display: flex;
  flex-direction: column;

  &.active {
    position: relative;
    > h3:after {
      content: '';
      position: absolute;
      bottom: 0px;
      left: 0;
      background-color: ${(props) => props.theme.colors.white};
      height: 100%;
      width: 4px;
    }
  }

  .secondary > h3 {
    padding-left: 12px;
    font-weight: 400;
    font-size: 16px;
  }

  .dropdown,
  .title {
    padding: 16px;
  }

  .dropdown {
    display: flex;
    justify-content: space-between;

    button,
    button:hover,
    button:active {
      color: ${(props) => props.theme.colors.white};
    }
  }
`;
